import React, { PureComponent } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import ConditionalRender from 'app/common/components/ConditionalRender';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { PDFDocumentProxy } from 'pdfjs-dist';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import './PDFViewer.less';
import { notification } from 'antd';
import Utils from 'app/common/util/Utils';
import { WorkerMessageHandler } from 'pdfjs-dist/build/pdf.worker.min.mjs';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(WorkerMessageHandler, import.meta.url).toString();

interface PDFViewerProps {
    file: number[] | String;
}

interface PDFViewerState {
    pageNumber: number;
    totalPages: number;
    loaded: boolean;
}

export class PDFViewer extends PureComponent<PDFViewerProps, PDFViewerState> {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            pageNumber: 0,
            totalPages: 0,
        };
    }

    componentDidUpdate(prevProps: Readonly<PDFViewerProps>) {
        if (Utils.isNotShallowEquals(prevProps.file, this.props.file)) {
            this.setState({
                loaded: false,
                pageNumber: 0,
                totalPages: 0,
            });
        }
    }

    render() {
        return (
            <div className="pdf-viewer">
                <ConditionalRender condition={Utils.isExists(this.props.file)}>
                    <Document
                        file={`data:application/pdf;base64,${this.props.file}`}
                        onLoadSuccess={this.onLoadSuccess}
                        onLoadError={this.onLoadError}
                        onSourceError={this.onLoadError}>
                        <Page pageNumber={this.state.pageNumber} onWheel={this.onWheel} />
                    </Document>
                    <ConditionalRender condition={this.state.loaded}>
                        <div className="page-controls">
                            <LeftOutlined
                                style={{ cursor: this.prevDisabled() ? 'not-allowed' : 'pointer' }}
                                onClick={this.prevPage}
                            />
                            <span>
                                {this.state.pageNumber} of {this.state.totalPages}
                            </span>
                            <RightOutlined
                                style={{ cursor: this.nextDisabled() ? 'not-allowed' : 'pointer' }}
                                onClick={this.nextPage}
                            />
                        </div>
                    </ConditionalRender>
                </ConditionalRender>
                <ConditionalRender condition={Utils.isNotExists(this.props.file)}>
                    <span>PDF file is not defined.</span>
                </ConditionalRender>
            </div>
        );
    }

    private onWheel = ({ deltaY }) => (deltaY > 0 ? this.nextPage() : this.prevPage());

    private onLoadError = error =>
        notification.error({
            message: 'Error loading OPS document',
            description: error.message,
        });

    private nextDisabled = () => this.state.pageNumber === this.state.totalPages;

    private prevDisabled = () => this.state.pageNumber === 1;

    private nextPage = () =>
        this.state.pageNumber < this.state.totalPages && this.setState({ pageNumber: this.state.pageNumber + 1 });

    private prevPage = () => this.state.pageNumber > 1 && this.setState({ pageNumber: this.state.pageNumber - 1 });

    private onLoadSuccess = ({ numPages: totalPages }: PDFDocumentProxy) => {
        this.setState({ loaded: true, totalPages, pageNumber: 1 });
    };
}
